import { HTMLAttributes } from "react"
import Block from "../Base/Block"
import View from "../Base/View"
import './index.scss'

const Loading = (prop: HTMLAttributes<HTMLDivElement>)=>{
    return  <Block>
    <View className="sk-fading-circle" {...prop}>
      <View className="sk-circle1 sk-circle"></View>
      <View className="sk-circle2 sk-circle"></View>
      <View className="sk-circle3 sk-circle"></View>
      <View className="sk-circle4 sk-circle"></View>
      <View className="sk-circle5 sk-circle"></View>
      <View className="sk-circle6 sk-circle"></View>
      <View className="sk-circle7 sk-circle"></View>
      <View className="sk-circle8 sk-circle"></View>
      <View className="sk-circle9 sk-circle"></View>
      <View className="sk-circle10 sk-circle"></View>
      <View className="sk-circle11 sk-circle"></View>
      <View className="sk-circle12 sk-circle"></View>
    </View>
  </Block>
}

export default Loading;